import { render } from "./CursorSpotlight.vue?vue&type=template&id=de56e6ae&scoped=true&ts=true"
import script from "./CursorSpotlight.vue?vue&type=script&lang=ts"
export * from "./CursorSpotlight.vue?vue&type=script&lang=ts"

import "./CursorSpotlight.vue?vue&type=style&index=0&id=de56e6ae&lang=scss&scoped=true"
import "./CursorSpotlight.vue?vue&type=style&index=1&id=de56e6ae&lang=scss"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.32_vue@3.5.32_typescript@5.1.6__webpack@5.106.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de56e6ae"]])

export default __exports__